export default __webpack_public_path__ + "static/media/Vector.ed772da8.svg";